import Grid from "@mui/material/Grid";

export default function TooltipField({ label, value, isHeader }) {
  return (
    <Grid container spacing={1} size={12}>
      {!isHeader && (
        <>
          <Grid className="tooltipField" size={6}>{`${label}:`}</Grid>
          <Grid className="tooltipField" textAlign="right" size={6}>
            {value}
          </Grid>
        </>
      )}

      {isHeader && (
        <Grid className="tooltipHeader" size={12}>
          {label}
        </Grid>
      )}
    </Grid>
  );
}
